























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatDrawerMenuBrand',
  model: {
    prop: 'show',
    event: 'toggle',
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    isShow: {
      get(): boolean {
        return this.show;
      },
      set(val: boolean): void {
        this.$emit('toggle', val);
      },
    },
  },
  methods: {
    onSignOut(event: Event) {
      event.preventDefault();
      // this.auth.signOut()
    },
  },
});
